var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderReformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61816 10.3311H10.3652C11.0635 10.3311 11.5859 10.1943 11.9326 9.9209C12.2793 9.64258 12.4526 9.23975 12.4526 8.7124C12.4526 8.18018 12.3062 7.78711 12.0132 7.5332C11.7251 7.2793 11.271 7.15234 10.6509 7.15234H9.61816V10.3311ZM14.7451 8.63184C14.7451 9.78418 14.3838 10.6655 13.6611 11.2759C12.9434 11.8862 11.9204 12.1914 10.5923 12.1914H9.61816V16H7.34766V5.29199H10.7681C12.0669 5.29199 13.0532 5.57275 13.7271 6.13428C14.4058 6.69092 14.7451 7.52344 14.7451 8.63184Z",
    fill: "#C40F11"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderReformation);
export default __webpack_public_path__ + "static/media/under-reformation.24fb01f456273a1f48b5092d4c7c60f3.svg";
export { ForwardRef as ReactComponent };